import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-white p-6 rounded-lg border" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4 text-center" }, "Estado de tareas", -1)
const _hoisted_3 = { class: "flex justify-center items-center h-[calc(100%-3rem)] space-x-12" }
const _hoisted_4 = { class: "flex flex-col items-center space-y-2" }
const _hoisted_5 = { class: "w-12 h-12 relative" }
const _hoisted_6 = {
  class: "w-12 h-12 text-red-500",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4",
  fill: "none",
  class: "opacity-25"
}, null, -1)
const _hoisted_8 = ["d"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 font-medium" }, "Vencidas", -1)
const _hoisted_10 = { class: "text-red-600 font-bold text-lg" }
const _hoisted_11 = { class: "flex flex-col items-center space-y-2" }
const _hoisted_12 = { class: "w-12 h-12 relative" }
const _hoisted_13 = {
  class: "w-12 h-12 text-yellow-500",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4",
  fill: "none",
  class: "opacity-25"
}, null, -1)
const _hoisted_15 = ["d"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 font-medium" }, "Por vencer", -1)
const _hoisted_17 = { class: "text-yellow-600 font-bold text-lg" }
const _hoisted_18 = { class: "flex flex-col items-center space-y-2" }
const _hoisted_19 = { class: "w-12 h-12 relative" }
const _hoisted_20 = {
  class: "w-12 h-12 text-green-500",
  viewBox: "0 0 24 24"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4",
  fill: "none",
  class: "opacity-25"
}, null, -1)
const _hoisted_22 = ["d"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 font-medium" }, "A tiempo", -1)
const _hoisted_24 = { class: "text-green-600 font-bold text-lg" }

import { computed } from 'vue';
import type ITask from '@/interfaces/ITask';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskStatusList',
  props: {
    items: {
        type: Array as () => Array<ITask>,
        required: true
    }
},
  setup(__props) {

const props = __props;

// Función auxiliar para convertir grados a radianes
const polarToCartesian = (centerX: number, centerY: number, radius: number, angleInDegrees: number) => {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
    };
}

// Función para crear el path del arco SVG
const describeArc = (x: number, y: number, radius: number, startAngle: number, endAngle: number) => {
    // Si el ángulo es 360 grados (círculo completo), usar un path diferente
    if (endAngle >= 359.9) {
        return [
            "M", x + radius, y,
            "A", radius, radius, 0, 1, 0, x - radius, y,
            "A", radius, radius, 0, 1, 0, x + radius, y,
            "Z"
        ].join(" ");
    }

    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    
    return [
        "M", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y,
        "L", x, y,
        "Z"
    ].join(" ");
}

const comprobarVencimiento = (date: Date) => {
    const fecha = new Date(date);
    const hoy = new Date();
    const casiVencida = new Date(fecha);
    casiVencida.setDate(casiVencida.getDate() - 1);

    if (fecha.getDate() === 1 && fecha.getMonth() === 0 && fecha.getFullYear() === 1900){
        return "en_tiempo";
    }

    if (fecha < hoy){
        return "vencida";
    } else if (casiVencida <= hoy){
        return "casi_vencida";
    } else {
        return "en_tiempo";
    }
}

const totalTareas = computed(() => props.items.length);

const vencidas = computed(() => 
    props.items.filter(item => 
        comprobarVencimiento(item.deadline ?? new Date()) === 'vencida'
    ).length
);

const porVencer = computed(() => 
    props.items.filter(item => 
        comprobarVencimiento(item.deadline ?? new Date()) === 'casi_vencida'
    ).length
);

const aTiempo = computed(() => 
    props.items.filter(item => 
        comprobarVencimiento(item.deadline ?? new Date()) === 'en_tiempo'
    ).length
);

// Calcular porcentajes para los arcos
const porcentajeVencidas = computed(() => 
    totalTareas.value > 0 ? (vencidas.value / totalTareas.value) * 360 : 0
);

const porcentajePorVencer = computed(() => 
    totalTareas.value > 0 ? (porVencer.value / totalTareas.value) * 360 : 0
);

const porcentajeATiempo = computed(() => 
    totalTareas.value > 0 ? (aTiempo.value / totalTareas.value) * 360 : 0
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("path", {
              d: describeArc(12, 12, 8, 0, porcentajeVencidas.value),
              fill: "currentColor",
              class: "opacity-75"
            }, null, 8, _hoisted_8)
          ]))
        ]),
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(vencidas.value), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(), _createElementBlock("svg", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("path", {
              d: describeArc(12, 12, 8, 0, porcentajePorVencer.value),
              fill: "currentColor",
              class: "opacity-75"
            }, null, 8, _hoisted_15)
          ]))
        ]),
        _hoisted_16,
        _createElementVNode("span", _hoisted_17, _toDisplayString(porVencer.value), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(), _createElementBlock("svg", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("path", {
              d: describeArc(12, 12, 8, 0, porcentajeATiempo.value),
              fill: "currentColor",
              class: "opacity-75"
            }, null, 8, _hoisted_22)
          ]))
        ]),
        _hoisted_23,
        _createElementVNode("span", _hoisted_24, _toDisplayString(aTiempo.value), 1)
      ])
    ])
  ]))
}
}

})